<template>
    <b-row class="mb-3">
        <b-col sm="12" md="2">
            <b-form-group>
                <label>Processo</label>
                <b-input-group>
                    <b-form-input type="text" v-model="processo"></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="2">
            <b-form-group>
                <label>Contrato</label>
                <b-input-group>
                    <b-form-input
                        type="text"
                        v-model="contrato"
                        v-mask="'AA###/##'"
                    ></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
            <b-form-group>
                <label>Fornecedor</label>
                <model-list-select
                    :list="fornecedores"
                    option-text="nome"
                    option-value="codFornecedor"
                    v-model="fornecedor"
                >
                </model-list-select>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
            <b-form-group>
                <label>Solicitante</label>
                <model-list-select
                    :list="solicitantes"
                    option-text="nome"
                    option-value="codFuncionario"
                    v-model="solicitante"
                >
                </model-list-select>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="2">
            <b-form-group>
                <label>Data Requisição (DE)</label>
                <date-picker
                    v-model="dataRequisicaoDe"
                    :config="$datePickerOptions2"
                    v-mask="'##/##/####'"
                ></date-picker>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="2">
            <b-form-group>
                <label>Data Requisição (ATÉ)</label>
                <date-picker
                    v-model="dataRequisicaoAte"
                    :config="$datePickerOptions2"
                    v-mask="'##/##/####'"
                ></date-picker>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="3">
            <b-form-group>
                <label>Situação</label>
                <model-list-select
                    :list="situacoes"
                    option-text="descrSituacao"
                    option-value="codSituacao"
                    v-model="situacao"
                >
                </model-list-select>
            </b-form-group>
        </b-col>
         <b-col sm="12" md="3">
            <b-form-group>
                <label>Situação solicitação</label>
                <model-list-select
                    :list="situacoesSolicitacao"
                    option-text="descrSituacao"
                    option-value="codSituacao"
                    v-model="situacaoSolicitacao"
                >
                </model-list-select>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="2">
            <div class="mt-4">
                <b-button variant="primary" class="mt-2 ml-1" @click="pesquisar()"
                    >Pesquisar</b-button
                >
                <b-button variant="primary" class="mt-2 ml-2" @click="limparFiltros()"
                    >Limpar Filtros</b-button
                >
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        dataServicos: {
            type: Object
        }
    },
    data() {
        return {
            processo: null,
            contrato: null,
            fornecedores: [],
            fornecedor: null,
            solicitantes: [],
            solicitante: null,
            dataRequisicaoDe: null,
            dataRequisicaoAte: null,
            situacoes: [],
            situacao: null,
            situacoesSolicitacao: [],
            situacaoSolicitacao: null,
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.fornecedores
                        this.solicitantes = response.data.solicitantes
                        this.situacoes = response.data.situacoes
                        this.situacoesSolicitacao = response.data.situacoesSolicitacao
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar() {
            let filtroDto = {
                processo: this.processo,
                contrato: this.contrato
                    ? this.contrato.replace('/', '-')
                    : this.contrato,
                fornecedor: this.fornecedor,
                solicitante: this.solicitante,
                dataRequisicaoDe: this.dataRequisicaoDe
                    ? this.$moment(this.dataRequisicaoDe, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataRequisicaoAte: this.dataRequisicaoAte
                    ? this.$moment(this.dataRequisicaoAte, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                situacao: this.situacao,
                situacaoSolicitacao: this.situacaoSolicitacao
            }
            this.$emit('pesquisar', filtroDto)
        },
        limparFiltros() {
            this.processo = null
            this.contrato = null
            this.fornecedor = null
            this.solicitante = null
            this.dataRequisicaoDe = null
            this.dataRequisicaoAte = null
            this.situacao = null
            this.situacaoSolicitacao = null
        }
    },

    mounted() {
        this.obterOpcoesFiltros()
    }
}
</script>